import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrevorIcon } from '@trevor/ui-components';
import { useGenerateSuggestedQuery } from '@/features/suggested-queries/suggestedQueriesApiSlice';
import { useDatasourceId } from '@/hooks';
import styles from './SuggestedQueryInfo.module.scss';

export type SuggestedQueryInfoProps = {
  name: string;
  suggestedBy: string;
  querySql: string;
};

export const SuggestedQueryInfo: React.FC<SuggestedQueryInfoProps> = ({
  name,
  suggestedBy,
  querySql,
}) => {
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  const [mutate] = useGenerateSuggestedQuery();

  const handleMutate = async () => {
    const result = await mutate(querySql);

    if ('data' in result) {
      navigate(`/datasources/${datasourceId}/queries/${result.data.queryId}`);
    }
  };

  return (
    <div className={styles.container} onClick={handleMutate}>
      <div>
        <h5 className={styles.name}>{name}</h5>
        <div className={`${styles.suggestedBy} faint`}>
          Suggested by {suggestedBy}
        </div>
      </div>
      <TrevorIcon name="logo-symbol" height="30.32" width="24" />
    </div>
  );
};
